/**
 * @generated SignedSource<<61299d90d2dac145f80568b9b56c7b06>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type UpdateUserInput = {
  email?: string | null | undefined;
  firstName?: string | null | undefined;
  gradeLevelId?: string | null | undefined;
  isActive?: boolean | null | undefined;
  lastName?: string | null | undefined;
  password?: string | null | undefined;
  roleIds?: ReadonlyArray<string> | null | undefined;
  siteIds?: ReadonlyArray<string> | null | undefined;
  userId: string;
};
export type UsersUpdateUsersMutation$variables = {
  input: UpdateUserInput;
};
export type UsersUpdateUsersMutation$data = {
  readonly updateUser: {
    readonly errors: ReadonlyArray<{
      readonly __typename: string;
      readonly message?: string;
    }> | null | undefined;
    readonly operationStatus: {
      readonly isSuccessful: boolean;
    } | null | undefined;
  };
};
export type UsersUpdateUsersMutation = {
  response: UsersUpdateUsersMutation$data;
  variables: UsersUpdateUsersMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "UpdateUserPayload",
    "kind": "LinkedField",
    "name": "updateUser",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "OperationStatus",
        "kind": "LinkedField",
        "name": "operationStatus",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "isSuccessful",
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": null,
        "kind": "LinkedField",
        "name": "errors",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "__typename",
            "storageKey": null
          },
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "message",
                "storageKey": null
              }
            ],
            "type": "Error",
            "abstractKey": "__isError"
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "UsersUpdateUsersMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "UsersUpdateUsersMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "c74eeed28d155d741348dfe60479f20a",
    "id": null,
    "metadata": {},
    "name": "UsersUpdateUsersMutation",
    "operationKind": "mutation",
    "text": "mutation UsersUpdateUsersMutation(\n  $input: UpdateUserInput!\n) {\n  updateUser(input: $input) {\n    operationStatus {\n      isSuccessful\n    }\n    errors {\n      __typename\n      ... on Error {\n        __isError: __typename\n        message\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "6001cfff114944574af5e8ad7ca30a6a";

export default node;
